<template>
  <div>
    <v-stepper-step :complete="currentStep > isStep" :editable="currentStep > isStep" :step="isStep">Update User Add-ons</v-stepper-step>
    <v-stepper-content :step="isStep">
        <v-expansion-panels style="width: calc(100% - 42px);" dense class="ml-1 mb-5">
          <template v-for="(user,i) in users">
            <v-expansion-panel :key="i">
              <v-expansion-panel-header>
                <span>
                  <b>{{user.id}}</b>
                  {{userExtNumber(user)}}
                  <template v-if="addonsChanged(user.addons)">
                    <v-icon small color="body">edit</v-icon>
                  </template>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-for="(group,groupi) in user.addons">
                  <span :key="groupi">
                    <template v-if="group.count<1">
                      <template v-for="(ad,i) in group.items">
                        <v-row :key="i" class="body--text">
                          <v-col cols="4">{{ad.name}}</v-col>
                          <v-col cols="3">£{{ad.price.toFixed(2)}}</v-col>
                          <v-col cols="5" class="py-1"><v-switch v-model="ad.selected" class="mt-0" hide-details></v-switch></v-col>
                        </v-row>
                      </template>
                    </template>
                    <template v-else>
                      <v-row class="body--text">
                        <v-col cols="4">{{group.name}}</v-col>
                        <v-col cols="3">£{{group.price.toFixed(2)}}</v-col>
                        <v-col cols="5" class="py-1">
                          <v-select dense outlined hide-details :items="group.items" item-text="name" item-value="id" item-disabled="disabled" v-model="group.selected" @change="addonChanged(user,groupi)"></v-select>
                        </v-col>
                      </v-row>
                    </template>
                  </span>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
        <v-divider></v-divider>
        <v-btn color="primary" small @click="nextStep();">Continue</v-btn>
    </v-stepper-content>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: ['currentStep','isStep','users','userAddons'],
    methods: {
      addonChanged(user,group){
        let addGroup = user.addons[group];
        if(addGroup.selected===null){
          addGroup.price = 0;
        }else{
          addGroup.price = this.userAddons[addGroup.selected].price;
        }
      },
      addonsChanged(addons){
        let changed = false;
        Object.keys(addons).forEach(k => {
          let group = addons[k];
          if(group.count<1){
            group.items.forEach(add => {
              if(add.selected!==add.iniSelected){ changed = true; }
            });
          }else{
            if(group.selected!==group.iniSelected){ changed = true; }
          }
        });
        return changed;
      },
      userExtNumber(user){
        let ext = (user.ext!==null)?user.ext:'';
        let hyph = (user.ext!==null&&user.number!==null)?' - ':'';
        let num = (user.number!==null)?`${user.number.number}`:'';
        if(ext!==''||num!==''){
          return `(${ext}${hyph}${num})`;
        }else{
          return ``;
        }
      },
      nextStep() {
        this.$emit('continue');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-application--is-ltr .theme--light.v-stepper--vertical {
    .v-stepper__step {
      padding: 15px;
      margin: 10px;
    }
  }
</style>
